<template>
  <div>
    <v-row>
      <v-col cols="6" class="pt-2 pb-0 mb-n4">
        <CommonDropDowns :isItTaxYearWithoutAllYears=true
            @change="dataFromCommonDropDowns" :taxYearValue="editedItem.taxYear"
            :isTaxYearWithoutAllDisabled="!isNewItem" />
      </v-col>
      <v-col cols="6" class="pt-2 pb-0 mb-n4">
        <v-text-field class="input-text-size my-5"
           small hide-details dense label="Tax ID" v-model.number="editedItem.taxId"
           :readonly="!isNewItem" :tabindex="!isNewItem ? -1 : 0"
           @change="onTaxIdEntry"
           @blur="onTaxIdEntry">
          </v-text-field>
      </v-col>
      <v-col cols="6" class="pt-2 pb-0 mb-n4">
        <v-text-field class="input-text-size my-2"
           small hide-details dense label="Tax District"  v-model="editedItem.schoolDistrict"
           readonly tabindex="-1"
           >
          </v-text-field>
      </v-col><v-col cols="6" class="pt-2 pb-0 mb-n4">
        <v-text-field class="input-text-size my-2"
           small hide-details dense label="Owner Name"
           :value="ownerName"
           readonly tabindex="-1">
          </v-text-field>
      </v-col>
      <v-col cols="6" class="pt-4 pb-0 mb-n4">
        <v-text-field class="input-text-size mt-4"
           small  dense label="Tax Due" v-model.number="editedItem.totalDue"
           readonly tabindex="-1"
           >
          </v-text-field>
      </v-col><v-col cols="6" class="pt-4 pb-0 mb-n4">
        <v-text-field class="input-text-size my-4"
           small hide-details dense label="Tax Paid"
           v-model.number="editedItem.totalPaid"
           readonly tabindex="-1" >
          </v-text-field>
      </v-col>
      <v-col cols="6" class="pt-2 pb-0 mb-n4">
        <v-text-field class="input-text-size my-4"
           small hide-details dense label="Tax Still Due"
           v-model.number="editedItem.taxStillDue"
            readonly tabindex="-1">
          </v-text-field>
      </v-col><v-col cols="6" class="pt-2 pb-0 mb-n4">
        <v-text-field class="input-text-size my-4"
           small  dense label="Protest Amount"
          v-model.number="editedItem.amountPaidUnderProtest"
          @blur="roundAmount('amountPaidUnderProtest')"
          @focus="amountToNum('amountPaidUnderProtest')"
          @input="handleUnderProtest"
          :rules="totalTaxVaidation"
          >
          </v-text-field>
      </v-col>
      <v-col cols="6" class="pt-2 pb-0 mb-n4">
        <v-text-field class="input-text-size my-4"
           small  dense label="Paid Not Protested"
           v-model.number="editedItem.amountPaidNoProtest"
          @blur="roundAmount('amountPaidNoProtest')"
           @focus="amountToNum('amountPaidNoProtest')"
            @input="handleNoProtest"
            :rules="totalTaxVaidation"

          >
          </v-text-field>
      </v-col>
      <v-col cols="6" class="pt-2 pb-0 mb-n4">
        <v-text-field class="input-text-size my-4"
           small hide-details dense label="Total Payment"
           v-model="editedItem.totalPayment"
           @blur="roundAmount('totalPayment')"
           @focus="amountToNum('totalPayment')"
           >
          </v-text-field>
      </v-col>
       <v-col cols="6" class="pt-2 pb-0 mb-n4" v-if="!isItFromPicklist">
        <v-text-field class="input-text-size my-4"
           small hide-details dense label="Tax Amt to Refund"
           v-model="editedItem.refundToTaxPayer"
           @blur="roundAmount('refundToTaxPayer')"
           @focus="amountToNum('refundToTaxPayer')"
           @input="handleRefundToTaxPayer"
           >
          </v-text-field>
      </v-col>
       <v-col cols="6" class="pt-2 pb-0 mb-n4" v-if="!isItFromPicklist">
        <v-text-field class="input-text-size my-4"
           small hide-details dense label="Tax amt to Release"
           v-model="editedItem.releaseToApportion"
           @blur="roundAmount('releaseToApportion')"
           @focus="amountToNum('releaseToApportion')"
           @input="handleReleaseToApportion"
           >
          </v-text-field>
      </v-col>
       <v-col cols="6" class="pt-2 pb-0 mb-n4" v-if="!isItFromPicklist">
        <v-text-field class="input-text-size my-4"
           small hide-details dense label="Interest to Refund"
           v-model="editedItem.interestOfRefund"
           @blur="roundAmount('interestOfRefund')"
           @focus="amountToNum('interestOfRefund')"
           >
          </v-text-field>
      </v-col>
       <v-col cols="6" class="pt-2 pb-0 mb-n4" v-if="!isItFromPicklist">
        <v-text-field class="input-text-size my-4"
           small hide-details dense label="Interest to Release"
           v-model="editedItem.interestOfRelease"
           @blur="roundAmount('interestOfRelease')"
           @focus="amountToNum('interestOfRelease')"
           >
          </v-text-field>
      </v-col>
      <v-col v-if="showFund"  cols="6" class="pt-2 pb-0 mb-n4">
        <v-select :items="funds"
         class="input-text-size"
         label="Shared Fund"
         item-text="fundDesc"
         item-value="_id"
         :value="editedItem.fund"
         @change="selectedFundList" />
        </v-col>
         <v-col  cols="6" class="pt-2 pb-0 mb-n4" v-if="!isItFromPicklist">
       <v-checkbox
            class="input-text-size radio-and-checekbox-size"
            label="Resolved"
            v-model="editedItem.resolved"
          ></v-checkbox>
        </v-col>

    </v-row>
  </div>
</template>

<script>
import {
  mapActions,
  mapGetters,
  mapMutations,
}
  from 'vuex';
import { amountFormat, amountToNumber } from '../../../util/shared/vue-global';
import CommonDropDowns from '../common-utils/CommonDropDowns.mixin.vue';
import { toFiscalYear } from '../../../util/shared/tmc-global';

const fundCrudKey = 'sharedFund';
export default {
  name: 'protestTaxDialog',
  components: {
    CommonDropDowns,
  },
  props: {
    baseCrudKey: {
      type: String,
      default: '',
    },
    showFund: {
      type: Boolean,
      default: false,
    },
    isItFromPicklist: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isUpdating: false, // Guard flag to prevent feedback loop
      criteria: {
        fundList: [],

      },
      criteriaStats: {
        allFunds: false,
      // allTaxUnits: false,
      },
    };
  },
  created() {
    this.initCriteria();
  },
  mounted() {
    this.initializeInfo();
  },
  computed: {
    ...mapGetters('base/crud', ['item', 'items', 'isVisible', 'index']),
    ...mapGetters(['todaysDate']),
    editedItem: {
      get() {
        const item = this.item(this.baseCrudKey);
        return item;
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },
    isNewItem() {
      return this.index(this.baseCrudKey) === -1;
    },
    isVisibleProp() {
      const visibleFlag = this.isVisible(this.baseCrudKey);
      if (visibleFlag === undefined) {
        return false;
      }
      return visibleFlag;
    },
    ownerName() {
      if (this.editedItem.ownerName === undefined || this.editedItem.ownerName === null || this.editedItem.ownerName === '') {
        return `${this.editedItem.name1 || ''} ${this.editedItem.name2 || ''}`.trim();
      }
      return this.editedItem.ownerName;
    },
    funds() {
      const fundObjs = this.items(fundCrudKey) || [];
      const updatedFundObj = fundObjs.map((f) => ({
        ...f,
        fundDesc: f.fund === '0000' ? f.description : `${f.fund} - ${f.description || ''}`,
      }));
      return [...updatedFundObj]; // { _id: null, fund: '', fundDesc: '' },
    },

    totalTaxVaidation() {
      const amountPaidUnderProtest = amountToNumber(this.editedItem.amountPaidUnderProtest || 0);
      const amountPaidNoProtest = amountToNumber(this.editedItem.amountPaidNoProtest || 0);
      const editedTotalPayment = amountToNumber(this.editedItem.totalPayment || 0);
      const totalPayment = amountPaidUnderProtest + amountPaidNoProtest;
      const isCalcEqual = (totalPayment === editedTotalPayment);
      return [
        () => isCalcEqual || 'protest and non protest amount is not equal of tax due',
      ];
    },
    // taxStillDueVaidation() {
    //   // const amountPaidUnderProtest =
    // amountToNumber(this.editedItem.amountPaidUnderProtest || 0);
    //   // const amountPaidNoProtest = amountToNumber(this.editedItem.amountPaidNoProtest || 0);
    //   // const taxDue = amountToNumber(this.editedItem.totalPayment);
    //   // const isCalcEqual = ((amountPaidUnderProtest
    //   //  + amountPaidNoProtest)
    //   //  === taxDue);
    //    this.editedItem.amountStillDue = (this.taxDue||0 - this.totalPaid||0);
    //   return [
    //     () => isCalcEqual || 'protest and non protest amount is not equal of tax due',
    //   ];
    // },
  },
  watch: {
    isVisibleProp(newVal) {
      if (newVal) {
        let keys = [];
        if (this.isItFromPicklist) {
          keys = ['taxStillDue',
            'amountPaidUnderProtest', 'amountPaidNoProtest', 'totalDue', 'totalPaid'];
        } else {
          keys = ['taxStillDue',
            'amountPaidUnderProtest', 'amountPaidNoProtest', 'taxDue', 'totalPaid', 'refundToTaxPayer', 'releaseToApportion', 'interestOfRelease', 'interestOfRefund'];
        }
        // eslint-disable-next-line array-callback-return
        keys.map((key) => {
          if (key in this.editedItem) {
            this.roundAmount(key);
          }
        });
        // Calculate totalPayment as sum of both protest fields
        // eslint-disable-next-line max-len
        this.editedItem.totalPayment = amountFormat(amountToNumber(this.editedItem.amountPaidUnderProtest) + amountToNumber(this.editedItem.amountPaidNoProtest));
      }
    },
    // 'editedItem.amountPaidUnderProtest': {
    //   handler(newVal) {
    //     if (newVal !== undefined && newVal !== null) {
    //       const underProtestAmount = amountToNumber(newVal || 0);
    //       const noProtestAmount = amountToNumber(this.editedItem.amountPaidNoProtest || 0);
    //       this.editedItem.totalPayment = amountFormat(underProtestAmount + noProtestAmount);
    //     }
    //   },
    // },
    // 'editedItem.amountPaidNoProtest': {
    //   handler(newVal) {
    //     if (newVal !== undefined && newVal !== null) {
    //       const underProtestAmount = amountToNumber(this.editedItem.amountPaidUnderProtest || 0);
    //       const noProtestAmount = amountToNumber(newVal || 0);
    //       this.editedItem.totalPayment = amountFormat(underProtestAmount + noProtestAmount);
    //     }
    //   },
    // },
  },
  methods: {
    ...mapMutations('base/crud', ['setItem']),
    ...mapMutations('tax/taxInquiryTabs', ['setpaymentMode']),
    ...mapActions('shared/fund', [
      'loadFunds',
    ]),
    ...mapActions('tax/taxInquires', [
      'loadTaxInquires',
    ]),
    ...mapActions('tax/taxProtests', [
      'loadTaxProtestPaidAmounts',
    ]),
    ...mapActions(['reAuth', 'flashWarn']),
    dataFromCommonDropDowns(val, whichField) {
      this.editedItem[whichField] = val;
      if (whichField === 'taxYear') {
        this.handleTaxInquiry();
      }
    },
    // Tax ID is readonly rather than disabled once the record is saved, so its @change/@blur
    // pair can now fire there. Re-running the inquiry would overwrite the district, owner and
    // amount fields the dialog is displaying, so only follow the field while entering a new one.
    // The taxYear path in dataFromCommonDropDowns still calls handleTaxInquiry directly.
    onTaxIdEntry() {
      if (!this.isNewItem) return;
      this.handleTaxInquiry();
    },
    async handleTaxInquiry() {
      const gqlField = {
        _id: '',
        taxType: '',
        baseId: '',
        taxYear: '',
        taxId: '',
        totalDue: '',
        name1: '',
        name2: '',
        totalPaid: '',
        totalTax: '',
        schoolDistrict: '',
      };
      if (!this.editedItem.taxYear || !this.editedItem.taxId) return;
      const criteria = { taxYear: this.editedItem.taxYear, taxId: this.editedItem.taxId };
      try {
        const data = await this.loadTaxInquires({ criteria, baseCrudKey: 'taxInquiryData', fields: gqlField });
        if (data.length > 0) {
          const [item] = (data || []);
          // const typeIsProtestTax = PROTEST_TAX_TYPES.includes(item.taxType);
          // this.errorMessage = !typeIsProtestTax ?
          // '*This record is not related to Protest Tax' : null;
          // Use actual values from picklist data or default to 0
          // const amountPaidUnderProtest = Number(item.amountPaidUnderProtest || 0);
          // const amountPaidNoProtest = Number(item.amountPaidNoProtest || 0);
          // picklist: the payment about to be made under protest
          const amountPaidUnderProtest = amountToNumber(item.totalTax || 0);
          const amountPaidNoProtest = 0;
          const totalDue = amountToNumber(item.totalDue);
          const taxStillDue = amountToNumber(item.totalDue);
          // Update editedItem as a whole object to trigger reactivity
          if (this.isItFromPicklist) {
            this.editedItem = {
              ...this.editedItem,
              taxInquiryTransaction: item._id,
              name1: item.name1,
              name2: item.name2,
              schoolDistrict: item.schoolDistrict,
              amountPaidUnderProtest,
              amountPaidNoProtest,
              // refundToTaxPayer,
              // releaseToApportion,
              totalDue,
              totalPaid: item.totalPaid,
              taxStillDue,
              totalPayment: item.totalPayment || (amountPaidUnderProtest + amountPaidNoProtest),
            };
          } else {
            // A protest added by hand is for money already paid, so start from what the
            // protest-flagged payment details say was paid under protest - the record's total
            // tax is neither what was paid nor what was protested.
            const paid = await this.loadTaxProtestPaidAmounts(criteria) || {};
            const paidUnderProtest = amountToNumber(paid.amountPaidUnderProtest);
            const paidNoProtest = amountToNumber(paid.amountPaidNoProtest);
            this.editedItem = {
              ...this.editedItem,
              taxInquiryTransaction: item._id,
              name1: item.name1,
              name2: item.name2,
              schoolDistrict: item.schoolDistrict,
              amountPaidUnderProtest: paidUnderProtest,
              amountPaidNoProtest: paidNoProtest,
              refundToTaxPayer: amountToNumber(paid.refundToTaxPayer),
              releaseToApportion: amountToNumber(paid.releaseToApportion),
              totalDue,
              totalPaid: item.totalPaid,
              taxStillDue,
              totalPayment: amountToNumber(paidUnderProtest + paidNoProtest),
            };
          }
        } else {
          // Clear all fields except taxYear and taxId when no tax record found
          const { taxYear, taxId } = this.editedItem;
          this.editedItem = {
            taxYear,
            taxId,
          };
          this.flashWarn('No tax record found!');
        }
      } catch (e) {
        this.errorMessage = 'Error loading tax inquiry data';
      }
    },
    handleNoProtest(value) {
      const newValue = amountToNumber(value);
      this.editedItem.amountPaidNoProtest = newValue;
      const { totalPayment } = this.editedItem;

      this.editedItem.amountPaidNoProtest = newValue;
      this.editedItem.amountPaidUnderProtest = amountToNumber(totalPayment) - newValue;
      if (!this.isItFromPicklist) {
        this.editedItem.releaseToApportion = this.editedItem.amountPaidUnderProtest
      - this.editedItem.refundToTaxPayer;
      }
      // Force reactivity update for new records
      this.$forceUpdate();
    },
    handleRefundToTaxPayer(value) {
      const newValue = amountToNumber(value);
      this.editedItem.refundToTaxPayer = newValue;
      const { amountPaidUnderProtest } = this.editedItem;
      this.editedItem.releaseToApportion = amountToNumber(amountPaidUnderProtest) - newValue;
      // Force reactivity update for new records
      this.$forceUpdate();
    },
    handleReleaseToApportion(value) {
      const newValue = amountToNumber(value);
      this.editedItem.releaseToApportion = newValue;
      const { amountPaidUnderProtest } = this.editedItem;
      this.editedItem.refundToTaxPayer = amountToNumber(amountPaidUnderProtest) - newValue;
      // Force reactivity update for new records
      this.$forceUpdate();
    },
    handleUnderProtest(value) {
      const newValue = amountToNumber(value);
      this.editedItem.amountPaidUnderProtest = newValue;
      const { totalPayment } = this.editedItem;

      // Calculate totalPayment as sum of both fields
      // const noProtestAmount = amountToNumber(this.editedItem.amountPaidNoProtest || 0);
      // this.editedItem.totalPayment = amountFormat(newValue + noProtestAmount);
      this.editedItem.amountPaidNoProtest = amountToNumber(totalPayment) - newValue;
      if (!this.isItFromPicklist) {
        this.editedItem.releaseToApportion = this.editedItem.amountPaidUnderProtest
        - this.editedItem.refundToTaxPayer;
      }
      // Force reactivity update for new records
      this.$forceUpdate();
    },
    // updateTotalPayment(type, newValue) {
    //   console.info('getdata', type);
    //   // Calculate totalPayment as sum of both protest fields
    //   // const underProtestAmount = amountToNumber(this.editedItem.amountPaidUnderProtest || 0);
    //   // const noProtestAmount = amountToNumber(this.editedItem.amountPaidNoProtest || 0);
    //   const { totalPayment } = this.editedItem;
    //   if (type === 'amountPaidUnderProtest') {
    //     console.info('getdata1', type, newValue, totalPayment);
    //     this.editedItem.amountPaidUnderProtest = amountToNumber(totalPayment) - newValue;
    //   } else if (type === 'amountPaidNoProtest') {
    //     console.info('getdata2', type);
    //     this.editedItem.amountPaidNoProtest = amountToNumber(totalPayment) - newValue;
    //   } else {
    //     // this.editedItem.totalPayment = amountFormat(underProtestAmount + noProtestAmount);
    //   }
    // },

    roundAmount(f) {
      this.editedItem[f] = amountFormat(amountToNumber(this.editedItem[f]));
    },
    amountToNum(f) {
      this.editedItem[f] = amountToNumber(this.editedItem[f]);
    },
    mapCollectionVal(itemList, itemValue) {
      // console.info('itemlist', itemList);
      return [...(itemList || []).map((item) => item[`${itemValue}`])];
    },
    initializeInfo() {
      let keys = [];
      if (this.isItFromPicklist) {
        keys = ['taxStillDue',
          'amountPaidUnderProtest', 'amountPaidNoProtest', 'taxDue', 'totalPaid'];
      } else {
        keys = ['taxStillDue',
          'amountPaidUnderProtest', 'amountPaidNoProtest', 'taxDue', 'totalPaid', 'refundToTaxPayer', 'releaseToApportion', 'interestOfRelease', 'interestOfRefund'];
      }

      // eslint-disable-next-line array-callback-return
      keys.map((key) => {
        if (key in this.editedItem) {
          this.roundAmount(key);
        }
      });
      // Calculate totalPayment as sum of both protest fields
      const underProtestAmount = amountToNumber(this.editedItem.amountPaidUnderProtest || 0);
      const noProtestAmount = amountToNumber(this.editedItem.amountPaidNoProtest || 0);
      this.editedItem.totalPayment = amountFormat(underProtestAmount + noProtestAmount);
    },
    loadFundList() {
      this.loadFunds({
        criteria: {
          fiscalYear: this.fiscalYear || 0,
          isProtest: true,
          protest: true,
          sortBy: [
            {
              column: 'fund',
              direction: 'asc',
            },
          ],
        },
        baseCrudKey: fundCrudKey,
      }).then(() => {
        this.criteria.fundList = this.mapCollectionVal(this.funds, 'description');
        /* Set select-all */
        this.criteriaStats.allFunds = true;
      });
    },
    initCriteria() {
      this.fiscalYear = toFiscalYear(new Date(this.todaysDate));
      this.loadFundList();
    },
    selectedFundList(val) {
      this.editedItem.fund = val;
    },
  },

};
</script>

<style>
.add-border {
  border: 1px solid grey !important;
}
.custom-red-text {
  color: red;
  font-weight: bold;
}
</style>
